export const leaseTypeDropdown = {
  ssiplfixedRent: "SSIPL Fixed Rent",
  franchiseFixedRent: "Franchise Fixed Rent",
  ssiplRevShare: "SSIPL Rev Share",
  franchiseRevShare: "Franchise Rev Share",
  ssiplFixedRevShare: "SSIPL Fixed  + REV share",
  franchiseFixedRevShare: "Franchise Fixed + Rev share",
};
